import API from "@/factories/api.factory";

function callAPI(method, endpoint, data, config) {
  return API[method](endpoint, data, config).then(response => response.data);
}

export function get(endpoint, data, config) {
  return callAPI("get", endpoint, data, config);
}

export function post(endpoint, data, config) {
  return callAPI("post", endpoint, data, config);
}

export function put(endpoint, data, config) {
  return callAPI("put", endpoint, data, config);
}

export function remove(endpoint, data) {
  return callAPI("delete", endpoint, data);
}
